<template>
  <CDropdown
    placement="bottom-end"
    :caret="false"
    in-nav
    class="c-header-nav-item d-md-down-none mx-2"
    add-menu-classes="pt-0 "
    v-bind:show.sync="observer"
  >
    <template #toggler>
      <CHeaderNavLink>
        <CIcon name="cilBell" size="custom-size" :height="32" viewBox="0 0 32 32" />
        <!-- <i class="fas fa-bell font-xl text-white"></i> -->
        <CBadge v-if="itemsCount" shape="pill" color="primary" style="margin-top: -22px; margin-left: -5px">
          {{ itemsCount }}
        </CBadge>
        <!-- <CBadge v-if="itemsCount" shape="pill" color="primary" style="min-width: 16px; min-height: 16px; line-height: 12px">
          {{ itemsCount }}
        </CBadge> -->
      </CHeaderNavLink>
    </template>
    <CDropdownHeader tag="div" class="text-left bg-light">
      <CRow>
        <CCol class="pt-2">
          <strong>{{ $t('notifications.title.notifications') }}</strong>
        </CCol>
        <CCol class="text-right">
          <button v-if="notifications.length > 0" type="button" class="btn btn-link" @click="clearAll()">
            {{ $t('notifications.button.clearAll') }}
          </button>
        </CCol>
      </CRow>
    </CDropdownHeader>
    <div class="view-area-notification">
      <div v-if="notifications.length == 0" style="max-width: 450px; min-width: 350px">
        <p class="text-center font-weight-bold pt-4">{{ $t('notifications.text.withoutNotification') }}</p>
      </div>
      <div v-if="notifications.length > 0">
        <div
          style="max-width: 450px; min-width: 350px"
          class="text-decoration-none item-selection dropdown-item"
          v-for="(item, index) in notifications"
          :key="index"
          @click.stop=""
        >
          <CContainer fluid class="px-0 pt-1">
            <CRow align-vertical="start" :gutters="false">
              <CCol sm="12" class="d-flex flex-row">
                <div class="d-inline-flex" style="min-width: 10px">
                  <i v-if="!item.isReaded" class="ball-notification bg-primary mt-1 mr-1"></i>
                </div>
                <div sm="10" class="flex-grow-1" style="cursor: pointer" @click="notificationClick(item)">
                  <div class="title-notification font-weight-normal font-sm text-secondary">
                    {{ $t(item.title).toUpperCase() }}
                  </div>
                  <div class="content-notification" style="white-space: normal">
                    <p class="mt-0 mb-2">
                      {{ $t(item.content) }}
                    </p>
                    <p class="d-block my-0">
                      {{ formatDate(item.date) }}
                    </p>
                  </div>
                </div>
                <div class="text-right close-notification ml-2">
                  <i @click.prevent="removeNotification(item.notificationId, index)" class="fal fa-times text-gray-500"></i>
                </div>
              </CCol>
            </CRow>
          </CContainer>
        </div>
        <div v-if="!hasMoreNotifications">
          <p class="text-center font-weight-bold pt-4">{{ $t('notifications.text.noMoreNotifications') }}</p>
        </div>
        <div v-if="hasMoreNotifications" class="text-center pt-2 pb-2">
          <button :disabled="blockGetMore" v-if="notifications.length > 0" type="button" class="btn btn-link" @click="getMore()">
            {{ $t('notifications.button.getMoreNotifications') }}
          </button>
        </div>
      </div>
    </div>
  </CDropdown>
</template>
<script>
import { DateTime } from 'luxon'
import services from '../services/services'
import redirectRoutes from '../redirectRoutes'
import { getItem } from '@/utils/StorageManager'

export default {
  name: 'TheHeaderDropdownNotif',
  computed: {
    itemsCount: function () {
      let newNotifications = this.notifications.filter((el) => !el.isReaded)
      return newNotifications.length > 0 ? newNotifications.length.toString() : null
    },
  },
  data() {
    return {
      blockGetMore: false,
      observer: false,
      hasMoreNotifications: false,
      qtdNotifications: 10,
      notifications: [
        // Model
        // {
        //   id: '123123',
        //   title: 'AUDIANCE IMPORTED',
        //   content: 'Lorem ipsum dolor sit amet, consectetur, Lorem ipsum dolor sit amet, consectetur',
        //   date: new Date().toISOString(),
        //   isReaded: false,
        //   type: 4,
        //   redirectTo: 'AudienceHistory'
        //   // fileName: <NomeDoArquivo+extensão>
        // }
      ],
    }
  },
  watch: {
    observer: function (newValue, oldValue) {
      if (newValue) {
        let notificationsRead = this.notifications.filter((elm) => !elm.isReaded)
        if (notificationsRead.length) {
          notificationsRead = notificationsRead.map((elm) => elm.notificationId)

          services.markAsRead(notificationsRead).then((res) => {
            // ? implementar alguma coisa
          })
        }
      }

      if (!newValue) {
        this.notifications = this.notifications.map((elem) => {
          elem.isReaded = true
          return elem
        })
      }
    },
  },
  methods: {
    formatDate(date) {
      var startUTC = DateTime.fromISO(date, { zone: 'utc' })
      let end = DateTime.fromJSDate(new Date())
      // let start = DateTime.fromJSDate(date);
      let result = end.diff(startUTC, ['months', 'days']).shiftTo('years', 'months', 'weeks', 'days', 'hours', 'minutes').values
      if (result.years > 0)
        return (
          result.years +
          (result.years === 1 ? ` - ${this.$t('general.dates.year')} ` : ` ${this.$t('general.dates.years')}  ${this.$t('general.dates.go')}`)
        )

      if (result.months > 0)
        return (
          result.months +
          (result.months === 1 ? `  ${this.$t('general.dates.month')} ` : ` ${this.$t('general.dates.months')} ${this.$t('general.dates.go')}`)
        )

      if (result.weeks > 0)
        return (
          result.weeks +
          (result.weeks === 1 ? `  ${this.$t('general.dates.week')} ` : ` ${this.$t('general.dates.weeks')} ${this.$t('general.dates.go')}`)
        )

      if (result.days > 0)
        return (
          result.days +
          (result.days === 1 ? `   ${this.$t('general.dates.day')} ` : ` ${this.$t('general.dates.days')}  ${this.$t('general.dates.go')}`)
        )

      if (result.hours > 0)
        return (
          result.hours +
          (result.hours === 1 ? `  ${this.$t('general.dates.hour')} ` : ` ${this.$t('general.dates.hours')}  ${this.$t('general.dates.go')}`)
        )

      if (result.minutes > 0) {
        if (result.minutes < 1) {
          return 'few seconds ago'
        }
        result.minutes = Math.floor(result.minutes)
        return (
          result.minutes +
          (result.minutes === 1 ? `  ${this.$t('general.dates.minute')} ` : `${this.$t('general.dates.minutes')}  ${this.$t('general.dates.go')}`)
        )
      }
    },
    removeNotification(notificationId, index) {
      services.removeOne(notificationId).then((res) => {
        this.notifications.splice(index, 1)
      })
    },
    notificationClick(notification) {
      if (notification) {
        switch (notification.type) {
          case 1:
            break
          case 2:
            break
          case 3:
            this.notificationFile(notification)
            break
          case 4:
            this.notificationRedirect(notification)
            break
          default:
            return
        }
      }
      this.observer = true
    },
    notificationFile(notification) {
      if (notification.fileName) {
        this.$router.push({ name: 'download', params: { file: notification.fileName } })
      } else {
        // TODO tratar erro
        return
      }
    },
    notificationRedirect(notification) {
      if (notification.redirectTo) {
        this.$router.push({ name: redirectRoutes(notification.redirectTo) })
      }
    },
    addNotification(notification) {
      this.notifications.push(...notification)
    },
    addNewNotification(notification) {
      this.notifications.unshift(...notification)
    },
    clearAll() {
      services.clearAll().then((res) => {
        this.notifications = []
      })
    },
    getMore() {
      if (this.notifications.length > 0) {
        let lastid = this.notifications.reverse()[0].notificationId
        this.blockGetMore = true
        services.getMore(this.qtdNotifications, lastid).then((res) => {
          this.blockGetMore = false
          this.hasMoreNotifications = res.data.data.length === this.qtdNotifications
          if (res.data.data.length > 0) {
            let notification = res.data.data
            this.addNotification(notification)

            let notificationsRead = notification.map((elm) => elm.notificationId)
            services.markAsRead(notificationsRead).then((res) => {
              // Algum tratemento
            })
          }
        })
      }
    },
    initLoopNotification() {
      if (!getItem('accessToken')) return

      let timeout = setTimeout(() => {
        if (this.notifications.length > 0) {
          services
            .getNew(this.notifications[0].notificationId)
            .then((res) => {
              if (res.data.data != null) {
                this.hasMoreNotifications = res.data.data.length === this.qtdNotifications
                if (res.data.data.length > 0) {
                  let notification = res.data.data
                  this.addNewNotification(notification)
                }
              } else {
                this.hasMoreNotifications = false
              }
            })
            .finally(() => this.initLoopNotification())
        } else {
          services
            .getNotification(this.qtdNotifications, 0)
            .then((res) => {
              if (res.data.data != null) {
                this.hasMoreNotifications = res.data.data.length === this.qtdNotifications
                if (res.data.data.length > 0) {
                  let notification = res.data.data
                  this.addNotification(notification)
                }
              } else {
                this.hasMoreNotifications = false
              }
            })
            .finally(() => this.initLoopNotification())
        }
      }, 5000)

      this.$store.commit('SET_NOTIFICATION_LOOP', timeout)
    },
  },
  mounted() {
    this.initLoopNotification()
  },
}
</script>

<style scoped lang="scss">
.bell {
  color: var(--gray-700);

  &:hover {
  }
}

.ball-notification {
  border-radius: 10px;
  height: 6px;
  width: 6px;

  display: inline-block;
  vertical-align: top;
}

.close-notification {
  position: relative;
  cursor: pointer;
  i {
    transform: translateY(-4px);
  }
}

.content-notification {
  font-size: 13px;

  p {
    line-height: 1.5;
  }
}

.item-selection {
  &:hover {
    background-color: #ffede7;
  }
  &:active {
    color: initial;
  }
}

.view-area-notification {
  max-height: 400px;
  overflow: auto;
}
</style>
